import { render, staticRenderFns } from "./SearchRefresh.vue?vue&type=template&id=32d8e31a&"
import script from "./SearchRefresh.vue?vue&type=script&lang=js&"
export * from "./SearchRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports